import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wancheng",
  "use": "icon-wancheng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wancheng\"><path d=\"M512 992C247.59322062 992 32 776.40677938 32 512S247.59322062 32 512 32s480 215.59322063 480 480-215.59322063 480-480 480zM512 97.08474594C283.38983094 97.08474594 97.08474594 283.38983094 97.08474594 512s186.305085 414.91525406 414.91525406 414.91525406 414.91525406-186.305085 414.91525406-414.91525406S740.61016906 97.08474594 512 97.08474594z\" /><path d=\"M721.89830469 350.91525406c-15.4576275-10.57627125-38.23728844-8.13559312-50.44067719 5.694915L465.62711844 599.86440688 346.03389875 500.61016906c-15.4576275-10.57627125-38.23728844-8.13559312-50.44067812 5.69491594s-8.94915281 34.98305063 6.50847468 45.55932187l146.44067719 121.22033907c15.4576275 10.57627125 38.23728844 8.13559312 50.44067812-5.694915l229.42372876-270.915255c12.20338969-14.64406781 8.94915281-34.98305063-6.50847469-45.55932188z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wancheng.svg
// module id = SWjJ
// module chunks = 16